import React from 'react';
import { Link } from 'react-router-dom';
import './WhyChooseUs.css';
import whyChooseImg from '../../assets/Home/WhyChooseUs.png';

const WhyChooseUs = () => {
  return (
    <section className="why-choose-section" id="why-choose-us">
      <div className="why-choose-container">
        
        {/* Left Column - Industrial Engineers Image */}
        <div className="why-choose-image-col">
          <img 
            src={whyChooseImg} 
            alt="DEXA Industrial Engineers working in manufacturing plant" 
            className="why-choose-img" 
            loading="lazy" 
          />
        </div>

        {/* Right Column - Header Info & 2-Feature Box */}
        <div className="why-choose-content-col">
          
          {/* Top Header & Paragraph */}
          <div className="why-choose-top-info">
            <span className="why-choose-tag">WHY CHOOSE DEXA</span>
            <h2 className="why-choose-title">
              Your Trusted Partner For Precision CNC Machinery & Industrial Solutions
            </h2>
            <p className="why-choose-desc">
              DEXA Innovation delivers reliable CNC and industrial machinery backed by expert consultation, professional installation, operator training, and dependable after-sales support. We help manufacturers improve productivity with solutions tailored to their production needs.
            </p>

            {/* Get a Quote CTA Button */}
            <Link to="/contact" className="why-choose-btn">
              <span>Get a Quote</span>
              <span className="why-choose-btn-arrow">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="7" y1="17" x2="17" y2="7"></line>
                  <polyline points="7 7 17 7 17 17"></polyline>
                </svg>
              </span>
            </Link>
          </div>

          {/* Bottom Light Gray 2-Column Feature Card */}
          <div className="why-choose-feature-card">
            
            {/* Feature 1: Premium Quality Machines */}
            <div className="why-choose-feature-item">
              <div className="why-choose-icon-box">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"></circle>
                  <circle cx="12" cy="12" r="6"></circle>
                  <circle cx="12" cy="12" r="2"></circle>
                </svg>
              </div>
              <h3 className="why-choose-feature-title">Premium Quality Machines</h3>
              <p className="why-choose-feature-text">
                Source high-performance machinery from trusted manufacturers.
              </p>
            </div>

            {/* Feature 2: Expert Consultation */}
            <div className="why-choose-feature-item">
              <div className="why-choose-icon-box">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M8.5 14.5A5 5 0 1 1 15.5 14.5L14 17.5H10L8.5 14.5Z"></path>
                  <path d="M10 21H14"></path>
                </svg>
              </div>
              <h3 className="why-choose-feature-title">Expert Consultation</h3>
              <p className="why-choose-feature-text">
                Helping you choose the right machine for your application.
              </p>
            </div>

          </div>

        </div>

      </div>
    </section>
  );
};

export default WhyChooseUs;
